const THEME_KEY = "tlp-theme";

export const getStoredTheme = () => {
  try {
    return localStorage.getItem(THEME_KEY);
  } catch {
    return null;
  }
};

export const applyTheme = (theme) => {
  document.documentElement.classList.toggle("light", theme === "light");
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    // storage unavailable; theme still applied for this session
  }
};
